// extracted by mini-css-extract-plugin
export var center = "_4g-2";
export var clickableRow = "_4g-5";
export var expandedRow = "_4g-7";
export var hoverable = "_4g-4";
export var left = "_4g-1";
export var right = "_4g-3";
export var row = "_4g-0";
export var selectedRow = "_4g-6";
export var summaryRow = "_4g-8";